import GetShopArticlesRequestModelBase from '../_generated/modelBases/get-shop-articles-request-model-base';

export default class GetShopArticlesRequestModel extends GetShopArticlesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
